import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderby'
})

export class OrderByPipe implements PipeTransform {
  transform(data: Array<any>, args: string): Array<any> {
    if (args && data) {
      return [...data].sort((a, b) => {
        if (a[args] < b[args]) {
          return -1;
        } else if (a[args] > b[args]) {
          return 1;
        } else {
          return 0;
        }
      });
    } else {
      return data;
    }
  }
}
